import React, { useEffect, useRef, useState } from 'react';
import { Ellipse, Circle, Path } from 'react-konva';
import TextBox from './TextBox';
import { useTransformer } from './TransformerContext';

const Callout = ({
    id,
    isSelected,
    onSelect,
    draggable,
    fill = "#e6f7ff",
    stroke = "#1890ff",
    strokeWidth = 2,
    opacity: opacity,
    x: x, y: y,
    ...props }) => {
    const { fontSize, fontStyle, align, textColor, fontFamily } = props
    const ellipseRef = useRef();
    const tailRef = useRef();
    const pointRef = useRef();
    const transformerRef = useTransformer();

    // useEffect(() => {
    //     if (ellipseRef.current) {
    //         ellipseRef.current.scale({ x: 1.0000001, y: 1.0000001 });
    //         ellipseRef.current.fire('transformend', { target: ellipseRef.current }, true);
    //     }
    // }, [fontSize, fontStyle]);


    const [points, setPoints] = useState({
        ellipse: {
            x: x,
            y: y,
            radiusX: 100,
            radiusY: 60
        },
        pointer: {
            baseAngle: Math.PI / 4,
            baseWidth: Math.PI / 12,
            tipX: x + 110,
            tipY: y + 50
        }
    });

    const getTipAngle = () => {
        const { x, y } = points.ellipse;
        const dx = points.pointer.tipX - x;
        const dy = points.pointer.tipY - y;
        return Math.atan2(dy, dx);
    };

    const getConnectionPoints = () => {
        const angle = getTipAngle();
        const halfWidth = points.pointer.baseWidth / 2;
        const { radiusX, radiusY } = points.ellipse;

        return {
            start: {
                x: points.ellipse.x + radiusX * Math.cos(angle - halfWidth),
                y: points.ellipse.y + radiusY * Math.sin(angle - halfWidth)
            },
            end: {
                x: points.ellipse.x + radiusX * Math.cos(angle + halfWidth),
                y: points.ellipse.y + radiusY * Math.sin(angle + halfWidth)
            }
        };
    };

    // Update tail path
    useEffect(() => {
        if (!tailRef.current) return;
        const { start, end } = getConnectionPoints();
        const pathData = `
      M ${start.x},${start.y}
      L ${points.pointer.tipX},${points.pointer.tipY}
      L ${end.x},${end.y}
    `;
        tailRef.current.data(pathData);
        tailRef.current.getLayer().batchDraw();
    }, [points]);

    // Attach transformer
    useEffect(() => {
        if (isSelected && transformerRef.current && ellipseRef.current) {
            transformerRef.current.nodes([ellipseRef.current]);
            transformerRef.current.getLayer().batchDraw();
        }
    }, [isSelected, transformerRef]);

    return (
        <>
            <Ellipse
                id={id}
                draggable={draggable}
                onClick={onSelect}
                onTap={onSelect}
                ref={ellipseRef}
                x={points.ellipse.x}
                y={points.ellipse.y}
                radiusX={points.ellipse.radiusX + 3}
                radiusY={points.ellipse.radiusY + 3}
                fill={fill}
                stroke={stroke}
                strokeWidth={strokeWidth}
                opacity={opacity}
                onDragMove={(e) => {
                    const { x, y } = e.target.position();
                    setPoints((prev) => ({
                        ...prev,
                        ellipse: {
                            ...prev.ellipse,
                            x,
                            y
                        },
                        // move pointer tip with ellipse
                        pointer: {
                            ...prev.pointer,
                            tipX: prev.pointer.tipX + (x - prev.ellipse.x),
                            tipY: prev.pointer.tipY + (y - prev.ellipse.y)
                        }
                    }));
                }}

                onTransformEnd={(e) => {
                    const { x, y } = e.target.position();
                    const node = ellipseRef.current;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();

                    const newRadiusX = points.ellipse.radiusX * scaleX;
                    const newRadiusY = points.ellipse.radiusY * scaleY;

                    // Reset scale to 1
                    node.scaleX(1);
                    node.scaleY(1);

                    setPoints((prev) => ({
                        ...prev,
                        ellipse: {
                            ...prev.ellipse,
                            radiusX: newRadiusX,
                            radiusY: newRadiusY,
                            x,
                            y
                        },
                        pointer: {
                            ...prev.pointer,
                            tipX: prev.pointer.tipX + ((x + 1) - prev.ellipse.x),
                            tipY: prev.pointer.tipY + (y - prev.ellipse.y)
                        }
                    }));
                }}
            />

            <Path
                ref={tailRef}
                stroke={stroke}
                strokeWidth={strokeWidth}
                fill={fill}
                opacity={opacity}
                closed
            />

            <Circle
                ref={pointRef}
                x={points.pointer.tipX}
                y={points.pointer.tipY}
                radius={8}
                fill="red"
                stroke="white"
                strokeWidth={2}
                opacity={0.5}
                draggable
                visible={isSelected}
                onDragMove={(e) => {
                    setPoints((prev) => ({
                        ...prev,
                        pointer: {
                            ...prev.pointer,
                            tipX: e.target.x(),
                            tipY: e.target.y()
                        }
                    }));
                }}
            />

            <TextBox
                id={id}
                onClick={onSelect}
                onTap={onSelect}
                x={points.ellipse.x}
                y={points.ellipse.y}
                fontSize={fontSize}
                fontStyle={fontStyle}
                align={align || "center"}
                textColor={textColor}
                fontFamily={fontFamily}
            />
        </>
    );
};

export default Callout;
